import { CKSelectableItem } from 'clearkit';

import { EnrichmentAttribute } from '~/generated/graphql';

import { FieldMapping, MappingProperty } from './types';
import { RecordType } from './useEnrichment/machineTypes';

export const isCompanyEnrichmentDisabled = (state: any, type: RecordType) => {
  const { companyPropertiesCount } = state.context;

  return type === 'company' && !companyPropertiesCount;
};

export const isContactEnrichmentDisabled = (state: any, type: RecordType) => {
  const { contactPropertiesCount } = state.context;

  return type === 'contact' && !contactPropertiesCount;
};

export const isLoading = (state: any) => {
  return (
    state.matches('loading') ||
    state.matches('loadingSchema') ||
    state.matches('loadingMappings')
  );
};

export const isVisible = (state: any) => {
  return (
    state.matches('editingMappings') ||
    state.matches('savingMappings') ||
    state.matches('refreshingProperties')
  );
};

export const isValidMapping = (mapping: FieldMapping) => {
  return mapping.sourceField && mapping.targetField && mapping.dataType;
};

export const lookupSelectableItem = (
  value: string,
  options: CKSelectableItem[],
) => {
  return options?.find((option) => option.value === value);
};

export const makeMappingProperty = (mapping: FieldMapping): MappingProperty => {
  return {
    clearbit: mapping.sourceField || '',
    hubspot: mapping.targetField || '',
  };
};

export const getFieldMetaData = (
  clearbitValue: string,
  clearbitAttributes: EnrichmentAttribute[],
) => {
  const attribute = clearbitAttributes?.find(
    (attribute) => attribute.value === clearbitValue,
  );

  return {
    sourceType: attribute?.meta.sourceType || '',
    dataType: attribute?.meta.dataType || '',
  };
};

export const getTransformedOptions = (
  recordType: RecordType,
  companyAttributes: EnrichmentAttribute[],
  personAttributes: EnrichmentAttribute[],
) => {
  return recordType === 'company'
    ? transformOptions(companyAttributes)
    : transformOptions(personAttributes);
};

export const pluralizeType = (type: RecordType) =>
  type === 'company' ? 'companies' : 'contacts';

export const transformOptions = (attributes: EnrichmentAttribute[]) => {
  const transformedOptions = attributes?.map((attribute) => {
    return {
      label: attribute.label,
      value: attribute.value,
    };
  });

  return transformedOptions;
};
